import { Input } from 'design-system';
import { useEffect, useMemo, useState } from 'react';
import './SearchBar.css';
import { useDebouncedValue } from '../../../../../hooks/useDebouncedValue';

const SearchBar = (props) => {
  const { setSearchInputValue, title, debounceDelay: debounceProp } = props;
  const [searchVal, setSearchVal] = useState('');
  const debounceDelay = useMemo(() => debounceProp ?? 400, [debounceProp]);
  const debouncedSearch = useDebouncedValue(searchVal, debounceDelay);

  useEffect(() => {
    if (typeof setSearchInputValue === 'function') {
      setSearchInputValue(debouncedSearch);
    }
  }, [debouncedSearch, setSearchInputValue]);

  return (
    <Input
      value={searchVal}
      onChange={(e) => setSearchVal(e.target.value)}
      placeholder={title}
    />
  );
};

export default SearchBar;
